import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    setTimeout(() => {
      const result = login(email, password);
      if (result.success) { navigate('/'); }
      else { setError(result.message); setLoading(false); }
    }, 600);
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-logo">
          <h1>✅ 결재시스템</h1>
          <p>사내 전자결재 플랫폼</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">이메일</label>
            <input className="form-input" type="email" placeholder="이메일 입력"
              value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label className="form-label">비밀번호</label>
            <input className="form-input" type="password" placeholder="비밀번호 입력"
              value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          {error && <p style={{color:'#ef4444', fontSize:13, marginBottom:12}}>{error}</p>}
          <button className="btn btn-primary" style={{width:'100%', justifyContent:'center', padding:'12px'}} disabled={loading}>
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>
        <div style={{marginTop:24, padding:16, background:'#f9fafb', borderRadius:8, fontSize:12, color:'#6b7280'}}>
          <p style={{fontWeight:600, marginBottom:8}}>테스트 계정</p>
          <p>👤 kim@company.com / 1234 (팀장)</p>
          <p>👤 lee@company.com / 1234 (대리)</p>
          <p>👤 park@company.com / 1234 (부장/관리자)</p>
        </div>
      </div>
    </div>
  );
}
